import _ from 'lodash';
import { CustomChartError } from '../components/chart-error/chart-error.util';
import { ChartSpecificColumnType, } from '../types/prism';
export const omitProperties = (obj, propertyNames) => {
    return _.transform(obj, (result, value, key) => {
        if (_.isObject(value)) {
            result[key] = omitProperties(value, propertyNames);
        }
        else if (!propertyNames.includes(key)) {
            result[key] = value;
        }
    });
};
export const omitTypenameProperty = (obj) => {
    return omitProperties(obj, ['__typename']);
};
export const isMeasureNameColumn = (column) => {
    return (column.chartSpecificColumnType === ChartSpecificColumnType.MeasureNames);
};
export const isMeasureValueColumn = (column) => {
    return (column.chartSpecificColumnType === ChartSpecificColumnType.MeasureValues);
};
export const filterMeasureColumns = (columns) => {
    return columns.filter((col) => !isMeasureNameColumn(col.column) &&
        !isMeasureValueColumn(col.column));
};
export function pTimeout(promise, ms, message) {
    return Promise.race([
        promise,
        new Promise((resolve, reject) => setTimeout(() => reject(new CustomChartError(message)), ms)),
    ]);
}
export const getChartType = (chartViz) => chartViz?.config?.chartType;
export function isSafariBrowser() {
    if (typeof navigator === 'undefined') {
        return false;
    }
    const userAgent = navigator.userAgent.toLowerCase();
    const hasSafariInUA = userAgent.includes('safari');
    const isChromiumBased = userAgent.includes('chrome') ||
        userAgent.includes('chromium') ||
        userAgent.includes('edg/') ||
        userAgent.includes('opr/') ||
        userAgent.includes('brave');
    return hasSafariInUA && !isChromiumBased;
}
//# sourceMappingURL=common-util.js.map